import React from "react";
import "react-phone-number-input/style.css";
import { sanitize } from "dompurify";
import noop from "lodash/noop";

import { styled } from "@mui/material/styles";
import PhoneInputBase from "react-phone-number-input";
export const PhoneInputStyled = styled(PhoneInputBase, {
  shouldForwardProp: (prop) => prop !== "error",
})(({ error }) => ({
  height: "42px",
  backgroundColor: "#F6F7FB",
  padding: "9px 8px",
  borderRadius: "4px",
  boxSizing: "border-box",

  boxShadow: `inset 0 0 0 1px ${error ? "#d32f2f" : "transparent"}`,

  "&:hover": {
    boxShadow: `inset 0 0 0 1px ${error ? "#d32f2f" : "#3BB8C1"}`,
  },
  "&:focus-within": {
    boxShadow: `inset 0 0 0 2px ${error ? "#d32f2f" : "#3BB8C1"}`,
  },
}));
  

export const InputForPhone = ({ name, value, setValue, error, disabled , setTouched = noop}) => {
  const defaultCountry = "US";

  return (
    <PhoneInputStyled
      disabled={disabled}
      error={error}
      name={name}
      value={sanitize(value)}
      country={defaultCountry}
      international={false}
      defaultCountry={defaultCountry}
      onChange={(value) => setValue(value || "")}
      countryOptionsOrder={["US", "CA", "..."]}
      onBlur={setTouched}
    />
  );
};

